type PaginatedResponse<T> = {
    content: T[];
    totalElements: number;
    totalPages: number;
    pageable: {
        pageNumber: number;
        pageSize: number;
        offset: number;
    };
    first: boolean;
    last: boolean;
    size: number;
    numberOfElements: number;
    pageNumber: number;
    empty: boolean;
};

export const createEmptyData = <T>(): PaginatedResponse<T> => ({
    content: [] as T[],
    totalElements: 0,
    totalPages: 0,
    pageable: {
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
    },
    first: true,
    last: true,
    size: 0,
    pageNumber: 0,
    numberOfElements: 0,
    empty: true,
});
